import { fetchMerchantPricingPlan } from '@/api';
import { ErrorMessageResponse, MerchantPricingPlan } from '@/types';
import { useSentryQuery } from '../utils/sentryQueryWrapper';

const FIVE_MINUTES_MS = 5 * 60 * 1000;
export const MERCHANT_PRICING_PLAN_QUERY_KEY = ['merchant-pricing-plan'];

/**
 * The tier moves at most once a night, so a 5-minute stale window is generous.
 *
 * defaultErrorMessage: '' is silent mode — the failure is reported INLINE on
 * the page instead of as a toast. This is a single-purpose read-only screen:
 * the merchant is looking at the one card that failed, and the toast viewport
 * is anchored bottom-end where it has already been caught covering an action.
 * One report, in the place they are looking.
 */
export const useFetchMerchantPricingPlan = () =>
  useSentryQuery<MerchantPricingPlan | null, ErrorMessageResponse>(
    MERCHANT_PRICING_PLAN_QUERY_KEY,
    fetchMerchantPricingPlan,
    { staleTime: FIVE_MINUTES_MS, defaultErrorMessage: '' },
  );
